import Tooltip from './component';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';

export default withStyles(styles)(Tooltip);
